<template>
  <div class="flex flex-wrap lg:flex-no-wrap overflow-hidden my-4 p-4 rounded w-full border border-transparent bg-grey-lighter border-grey">
    <div class="w-full">
      <label>
        <input
          :checked="locationFilter.showClosed"
          @change="updateShowClosed"
          type="checkbox"
        >
        Aktuell geschlossene Anbieter anzeigen
      </label>
    </div>
    <div class="w-full">
      <label>
        <input
          :checked="locationFilter.showPickups"
          @change="updateShowPickups"
          type="checkbox"
        >
        Anbieter ohne Lieferung anzeigen
      </label>
    </div>
    <div class="w-full pt-4 lg:pt-0">
      <label>
        <select @change="updateFoodType" class="w-full">
          <option :value="null">- Alle Küchenarten -</option>
          <option v-for="foodtype in foodtypes" :key="foodtype" :selected="locationFilter.foodType === foodtype">{{ foodtype }}</option>
        </select>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HostFilter',

  props: {
    value: {
      type: Object,
      required: false
    },
    foodtypes: {
      type: Object,
      required: false
    }
  },

  computed: {
    ...mapGetters([
      'locationFilter'
    ])
  },

  methods: {
    ...mapMutations([
      'updateShowPickupsFilter',
      'updateShowClosedFilter',
      'updateFoodTypeFilter'
    ]),

    updateShowPickups (e) {
      this.updateShowPickupsFilter(e.target.checked)
    },

    updateShowClosed (e) {
      this.updateShowClosedFilter(e.target.checked)
    },

    updateFoodType (e) {
      this.updateFoodTypeFilter(e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .ease-in-300{
    transition: all .3s ease-in;
  }

  .not-visible{
    width: 0;
    visibility: hidden;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/HostFilter.vue